export default __webpack_public_path__ + "static/kubernetes-4f05f4bdb11fec03ae057be34f156d87.svg";